export type PopupMessage = {
    key: string
    message: string
    query: object
}

export const PopupKeyMap = {
    RESULT_GIFT: 'RESULT_GIFT',
}

export const PopupSize = {
    common: {
        width: 500,
        height: 640,
    },
    bookingVisitDelivery: {
        width: 560,
        height: 800,
    },
}

/**
 * 팝업으로 열리는 주문서의 기본 사이즈. 피그마 참조
 * 디지털 컨텐츠 단건/정기, 예약방문주문서, 예약방문주문서 결제수단 설정, 주문형 정기구독 자동결제수단 설정 팝업에 해당.
 * https://oss.fin.navercorp.com/Product-Planning/Online-Payment_Plan/issues/575#issuecomment-1891631
 * https://www.figma.com/design/OH16fz0SrZEmSERXV5uWVR/%F0%9F%93%8D--%EA%B2%B0%EC%A0%9C%EC%B0%BD--%EA%B2%B0%EC%A0%9C%ED%98%95-%EA%B0%9C%ED%8E%B8--2024.%ED%95%98%EB%B0%98%EA%B8%B0-%EB%AA%A9%ED%91%9C-?node-id=15168-92021&t=JGNip5W1uJjs6380-0
 */
export const FixedSheetPopupSize = {
    innerWidth: 500,
    innerHeight: 920,
}
